import React, { useState } from 'react';
import { Helmet } from 'react-helmet';

const Faq = () => {
    const [activeIndex, setActiveIndex] = useState(0);

    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const faqs = [
        {
            question: "What services does Elly Decor provide for curtains?",
            answer: "Elly Decor offers professional curtain stitching and installation services. We ensure perfect fitting, premium quality fabrics, and timely installation to enhance your living spaces."
        },
        {
            question: "Does Elly Decor provide wallpaper consultation?",
            answer: "Yes, Elly Decor provides expert wallpaper consultation and professional application services with a wide range of patterns, textures, and colors to transform your walls."
        },
        {
            question: "What makes Elly Decor wallpapers unique?",
            answer: "Our wallpapers are easy to apply, available in diverse styles, and made from durable, high-quality materials to suit different tastes."
        },
        {
            question: "Does Elly Decor offer home makeover packages?",
            answer: "Yes, Elly Decor’s Home Makeover Packages include customized furniture, upholstery, and decor options to match your style, with expert advice and a variety of textures and colors."
        },
        {
            question: "Can Elly Decor handle commercial décor projects?",
            answer: "Absolutely! Elly Decor provides specialized commercial décor solutions for offices, hotels, and other commercial spaces, blending aesthetics with functionality."
        },
        {
            question: "What kind of furniture transformation does Elly Decor provide?",
            answer: "We offer furniture makeovers with a variety of textures, fabrics, and finishes to give your old furniture a stylish, modern look."
        },
        {
            question: "Does Elly Decor help with space planning?",
            answer: "Yes, our experts provide advice on how to arrange furniture, upholstery, and décor for a well-coordinated and functional home or office setup."
        },
        {
            question: "Are Elly Decor’s services suitable for hotels and offices?",
            answer: "Yes, our commercial décor solutions are tailored for offices, hotels, and professional environments, ensuring elegant and functional designs."
        }
    ];


    const faqSchema = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": faqs.map((faq) => ({
            "@type": "Question",
            "name": faq.question,
            "acceptedAnswer": {
                "@type": "Answer",
                "text": faq.answer
            }
        }))
    };

    return (
        <>
            <Helmet>
                <title>FAQs | Niya Living - Get Your Questions Answered</title>
                <meta name="title" content="FAQs | Niya Living - Get Your Questions Answered" />
                <meta name="description" content="Visit Niya Living's FAQs page for answers to common questions about our products, services, and policies. Find helpful information to guide your shopping experience." />
                <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
            </Helmet>

            <section
                className="about-page-title"
                style={{ backgroundImage: `url('/images/about-us.png')` }}
            >
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-12">
                            <h1 className="title">FAQ'S</h1>
                        </div>
                    </div>
                </div>
            </section>

            <section className="faqs-section-home1 my-5 pb-md-20">
                <div className="auto-container">
                    <div className="row">
                        <div className="faq-column col-lg-12">
                            <div className="inner-column">
                                <ul className="accordion-box wow fadeInLeft">
                                    {faqs.map((faq, index) => (
                                        <li
                                            key={index}
                                            className={`accordion block ${activeIndex === index ? 'active-block' : ''}`}
                                        >
                                            <div
                                                className={`acc-btn ${activeIndex === index ? 'active' : ''}`}
                                                onClick={() => toggleAccordion(index)}
                                            >
                                                {faq.question}
                                                <div className="arrow far fa-arrow-right"></div>
                                            </div>
                                            <div className={`acc-content ${activeIndex === index ? 'current' : ''}`}>
                                                <div className="content">
                                                    <div className="text">{faq.answer}</div>
                                                </div>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Faq;
